import { registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import localeEn from '@angular/common/locales/en';
import localePl from '@angular/common/locales/pl';
import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { AES256 } from '@awesome-cordova-plugins/aes-256/ngx';
import { AppVersion } from '@awesome-cordova-plugins/app-version/ngx';
import { FileOpener } from '@awesome-cordova-plugins/file-opener/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { ScreenOrientation } from '@awesome-cordova-plugins/screen-orientation/ngx';
import { SmsRetriever } from '@awesome-cordova-plugins/sms-retriever/ngx';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import * as SentryAngular from '@sentry/angular';
import { IonicNativeSentryInterceptor } from '../interceptors/ionic-native-sentry.interceptor';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { navTransitionFade } from './other/component-animations';
import { ApiService } from './services/api.service';
import { StorageService } from './services/storage.service';
import { TranslocoRootModule } from './transloco/transloco-root.module';

registerLocaleData(localePl);
registerLocaleData(localeEn);

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    IonicModule.forRoot({
      swipeBackEnabled: true,
      mode: 'md',
      navAnimation: navTransitionFade,
    }),
    AppRoutingModule,
    HttpClientModule,
    TranslocoRootModule,
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: IonicNativeSentryInterceptor,
      multi: true,
    },
    SmsRetriever,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    AppVersion,
    ApiService,
    FileOpener,
    HTTP,
    Title,
    ScreenOrientation,
    StorageService,
    AES256,
    {
      provide: ErrorHandler,
      useValue: SentryAngular.createErrorHandler(),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
